import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../../Utilities/DataLayer';
import Formatter from '../../Utilities/Formatter';

class RecruitCard extends Component {
    constructor(props) {
        super(props);
        this.formatter = new Formatter();

    }



    render() {
        return (
            <div>

                <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                    <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.recruitName}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="phone" />&nbsp;&nbsp;{this.props.telephoneCell}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Code:&nbsp;{this.props.sfCurrentCode}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Start Week:&nbsp;{this.props.recruitedWeek}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Qualified:&nbsp;{this.props.qualified ? (<MDBIcon icon="user-check" style={{ color: "green" }} />) : (<MDBIcon icon="user-times" style={{color:"red"}}/>)}</MDBCardTitle>
                    <hr />
                    <MDBCardText>
                        <MDBRow>
                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                <span style={{ fontSize: "14px" }}>Sales This Seg</span><br /> <strong>{this.formatter.formatCurrency(this.props.segmentSales)}</strong>
                            </MDBCol>
                            <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                <span style={{ fontSize: "14px" }}>Sales This Week</span><br /> <strong>{this.formatter.formatCurrency(this.props.currentWeekSales)}</strong>
                            </MDBCol>
                        </MDBRow>
                    </MDBCardText>
                    <hr />
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Recruiter:&nbsp;{this.props.recruiter}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;Unit:&nbsp;{this.props.unitName}</MDBCardTitle>
                </MDBCard>

            </div>
        )
    }
}

export default RecruitCard;